<template>
  <div class="mt-2rem mb-10rem">
    <section>
      <v-container>
        <v-row>
          <v-col cols="12" sm="7">
            <h1 class="display-3 font-weight-black mb-10">Jindo coin 👌 <br> symbol and logotype</h1>
            <p>
              Download vector and .png versions of our symbol and logotype.
              Please be friendly with Jindo Coin branding.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="mb-5rem">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in brandAssets"
            :key="index"
            cols="12" sm="4"
            class="text-center mb-5rem">
            <v-card
              min-height="240"
              class="mb-2 d-flex align-center"
              outlined>
              <v-card-text class="pa-4">
                <v-img class="mx-auto"
                :max-width="item.width"
                  :src="item.src" alt="logo">
                </v-img>
              </v-card-text>
            </v-card>
            <span
              @click="onClickDownload(item.filePng, item.name)"
              class="body-2 text-decoration-underline">
              {{item.caption}}
            </span>
          </v-col>
          <v-col cols="12" sm="6">
            <p class="grey--text">
              Please don’t use our name, logos, or screenshots in
              ways that may be confusing, misleading.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-btn text outlined rounded
          href="mailto:hellojindocoin@gmail.com">
          (Biz inquiries only)
        </v-btn>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Press-kit',
  metaInfo: {
    title: 'Press Kit',
    titleTemplate: '%s - download versions of our symbol and logotype'
  },
  data: () => ({
    brandAssets: [
      {
        src: require('@/assets/brand-assets/jindo-symbol.svg'),
        filePng: require('@/assets/brand-assets/files/png/jindo-symbol.png'),
        caption: 'Download symbol (png)',
        name: 'jindo-symbol.png',
        width: '100'
      },
      {
        src: require('@/assets/brand-assets/jindo-logotype.svg'),
        filePng: require('@/assets/brand-assets/files/png/jindo-logotype.png'),
        caption: 'Download symbol (png)',
        name: 'jindo-logotype.png',
        width: '300'
      },
      {
        src: require('@/assets/brand-assets/jindo-logotype-stacked.svg'),
        filePng: require('@/assets/brand-assets/files/png/jindo-logotype-stacked.png'),
        caption: 'Download symbol (png)',
        name: 'jindo-logotype-stacked.png',
        width: '100'
      }
    ]
  }),
  methods: {
    async onClickDownload (url, name) {
      try {
        const resp = await this.$axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        })
        console.log(resp)
        this.forceFileDownload(resp, name)
      } catch (err) {
        console.log(err)
      }
    },
    forceFileDownload (resp, name) {
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
